/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { CopyrightNoticeProps } from './index';

/**
 * Base styles for the copyright notice component
 *
 * @param {CopyrightNoticeProps} props The copyright notice properties object
 * */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
const baseStyles = (props: CopyrightNoticeProps) => css`
    margin: 0;
    display: inline-block;
    ${theme.typography.caption}
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

/**
 * The copyright notice component styles
 *
 * @param {CopyrightNoticeProps} props The copyright notice properties object
 * */
export const styles = (props: CopyrightNoticeProps) => css`
    ${baseStyles(props)}
`;
